
class ProductFilter{

    constructor(aSelector='.snookfun-product-item'){
        this.selector = aSelector;
    }
    
    showAll(){
        $(this.selector).show();
    }
    
    hideAll(){
        $(this.selector).hide();
    }
    
    showProducts(aIDs){
                
        if(aIDs.length>0){
            $(this.buildSelectorsForProducts(aIDs)).show();
        }
    
    }
    
    hideProducts(aIDs){
        
        if(aIDs.length>0){
            $(this.buildSelectorsForProducts(aIDs)).hide();
        }
        
    }
    
    buildSelectorsForProducts(aIDs){
        let ids = aIDs.map((aValue) => {
            return this.selector+'[data-product='+aValue+']';
        });
        
        return (ids.length===1) ? ids[0] : ids.join(',');
    }
    
}

export default ProductFilter;